import NAME from "./constants";

export const OPEN_DIALOG = NAME + "/OPEN_DIALOG";
export const CLOSE_DIALOG = NAME + "/CLOSE_DIALOG";
